/*global angular*/

angular.module( 'clinkModification', 
		[
//			'ngCookies',
//			'ngResource',
//			'ngSanitize',
//			'ngCsv',
//			'ngRoute',
//			'ui.bootstrap',
//			'ngDialog',
//			'ngStorage',
//			'ngTagsInput',
//			'digestHud',
//			'apt'
		] );
